var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { DataProcessingJobCreate } from "./DataProcessingJobCreate";
export class CustomSourceDataProcessingJobCreate extends DataProcessingJobCreate {
  constructor(_data) {
    super();
    /**
     */
    __publicField(this, "Type");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof CustomSourceDataProcessingJobCreate
     */
    __publicField(this, "$type", "V1.DataProcessingJobs.CustomSourceDataProcessingJobCreate");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    super.init(_data);
    if (_data) {
      this.Type = CustomSourceDataProcessingJobCreateType[_data["Type"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    super.toJSON(_data);
    _data["Type"] = CustomSourceDataProcessingJobCreateType[this.Type];
    return _data;
  }
}
export var CustomSourceDataProcessingJobCreateType = /* @__PURE__ */ ((CustomSourceDataProcessingJobCreateType2) => {
  CustomSourceDataProcessingJobCreateType2["Sale"] = "Sale";
  CustomSourceDataProcessingJobCreateType2["Purchase"] = "Purchase";
  CustomSourceDataProcessingJobCreateType2["One"] = "One";
  return CustomSourceDataProcessingJobCreateType2;
})(CustomSourceDataProcessingJobCreateType || {});
